import { Serializable } from './base';

export class QRCode implements Serializable<QRCode> {
    code: string;
    deserialize(input) {
       this.code = input.code;
        return this;
    }
}
